module.exports = __webpack_public_path__ + "static/media/banking.df0ba93c.png";